<template>
  <v-navigation-drawer v-model="drawerVal" fixed temporary app clipped>
    <div v-for="(item, i) in side_bar_items" :key="i">
      <div v-if="item.links">
        <v-list dense nav>
          <v-list-item
            v-for="(link, i) in item.links"
            :key="i"
            :to="{ name: link.link }"
            v-if="link.show"
            link
          >
            <v-list-item-icon class="mr-0">
              <v-icon small>
                {{ link.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ link.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <div v-if="item.divider">
        <v-divider />
      </div>
    </div>
    <v-list dense nav>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <div>
              <BtnTheme />
            </div>
            <div class="pt-1 pl-1 user-email">
              {{ $store.getters.getAuth.user.email }}
            </div>
            <div class="pl-1 version">V{{ app_version }}</div>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { APP_VERSION } from "@/general";
import { getSideBarItems } from "@/router/sideBarItems";
import VisAvatar from "@/components/VisAvatar.vue";
import BtnTheme from "@/components/BtnTheme.vue";

export default {
  props: ["drawer"],
  components: {
    VisAvatar,
    BtnTheme,
  },
  data() {
    return {
      app_version: APP_VERSION,
      auth: this.$store.getters.getAuth,
      side_bar_items: getSideBarItems(),
    };
  },
  computed: {
    drawerVal: {
      get() {
        return this.drawer;
      },
      set(v) {
        this.$emit("update:drawer", v);
      },
    },
  },
  methods: {},
};
</script>

<style scoped>
.user-email {
  font-size: 11px;
}
.version {
  font-size: 9px !important;
}
.v-size--x-small {
  font-size: 9px !important;
}
</style>
